export default __webpack_public_path__ + "static/media/284.68e359cc.jpg";